import m from 'mithril';
import {trans, has_permission} from "./helpers";

import SelectExercises from './new_challenge_creator/selectExercises.js';
import CreateExercise from './new_challenge_creator/createExercise.js';
import CreateChallenge from "./new_challenge_creator/createChallenge.js";
import EditExerciseContent from "./new_challenge_creator/editExerciseContent.js";
import ChallengeVisibility from "./new_challenge_creator/challengeVisibility.js";
import ChallengeCreated from "./new_challenge_creator/challengeCreated.js";

let challenge_state = require('./new_challenge_creator/challengeState.js');

class Challenge{
    oninit() {
        challenge_state.challenge = challenge_state.get_empty_challenge();
        challenge_state.new_exercise = challenge_state.get_empty_exercise();

        challenge_state.current_step = 'loading';

        if (challenge_state.id_challenge) {
            challenge_state.mode = 'update';
        } else {
            challenge_state.mode = 'insert';
        }

        if (challenge_state.mode == 'insert') {
            challenge_state.current_step = 'select_exercises';
        }
    }
    
    view() {
        return [
            challenge_state.current_step == 'loading' &&
            m('.general-loader', ''),

            challenge_state.current_step == 'select_exercises' &&
            m(SelectExercises),

            challenge_state.current_step == 'create_exercise' &&
            m(CreateExercise),

            challenge_state.current_step == 'create_challenge' &&
            m(CreateChallenge),

            challenge_state.current_step == 'edit_exercise_content' &&
            m(EditExerciseContent),

            challenge_state.current_step == 'challenge_visibility' &&
            m(ChallengeVisibility),

            challenge_state.current_step == 'challenge_created' &&
            m(ChallengeCreated),

            challenge_state.current_step == 'saving_challenge' &&
            m('div', trans('challenge.saving')),

            challenge_state.current_step == 'not_permitted_to_edit_public' &&
            [
                m('div', trans('challenge.not_permitted_to_edit_public_text')),
                m('br'),
                m('a.btn.btn--main', {
                    href: '/myprofile/challenges',
                }, trans('challenge.back_to_profile')),
            ]
        ]
    }
}

function get_challenge() {
    m.request('/api/challenge' +
        '?id_challenge='+ encodeURIComponent(challenge_state.id_challenge) +
        '&part=info,exercises,content,organizations,roles,group_items,sports')
        .then(d => {
            challenge_state.challenge.title = d.title; 
            challenge_state.challenge.subtitle = d.subtitle; 
            challenge_state.challenge.slug = d.slug; 
            challenge_state.challenge.description = d.description; 
            challenge_state.challenge.id_type = d.id_type; 
            challenge_state.challenge.id_entry_type = d.id_entry_type; 
            challenge_state.challenge.url_poster = d.url_poster; 
            challenge_state.challenge.available = d.available; 
            challenge_state.challenge.validated = d.validated*1; 
            challenge_state.challenge.requested_public = d.requested_public*1; 
            challenge_state.challenge.public = d.public*1; 
            challenge_state.challenge.unlisted = d.unlisted*1; 
            challenge_state.challenge.exposed = d.exposed*1; 
            challenge_state.challenge.is_sst = d.is_sst*1; 
            challenge_state.challenge.data = !Array.isArray(d.data) ? d.data : {}; 
            
            challenge_state.challenge.exercises = d.exercises.map(exercise => {
                exercise['id_exercise'] = exercise.id_exercise*1;
                exercise['inserted_at'] = new Date(exercise['inserted_at']).toLocaleDateString("sl-SI");
                return exercise;
            }); 
            // challenge_state.challenge.exercises = d.exercises; 

            challenge_state.challenge.roles = d.roles; 
            
            challenge_state.challenge.organizations = {
                list: d.organizations
            }; 

            challenge_state.challenge.sports = {
                list: d.sports
            }; 
            

            let groups = {};

            d.group_items.forEach(group_item => {
                if (!(group_item.group_code in groups)) {
                    groups[group_item.group_code] = {
                        id_group: group_item.id_group*1,
                        list: []
                    };
                }

                groups[group_item.group_code].list.push({
                    id_group_item: group_item.id_group_item*1,
                    title: group_item.title,
                    code: group_item.code
                });
            });


            challenge_state.challenge.groups = groups;
            // console.log(groups);

            challenge_state.challenge.starts_at = d.starts_at ? d.starts_at.split(' ')[0] : null; 
            challenge_state.challenge.ends_at = d.ends_at ? d.ends_at.split(' ')[0] : null;

            if (challenge_state.challenge.validated == 1 && challenge_state.challenge.requested_public == 1 && !has_permission('challenges.canCreatePublic')) {
                challenge_state.current_step = 'not_permitted_to_edit_public';
            } else {
                challenge_state.current_step = 'select_exercises';
            }

        })
        .catch(e => {
            alert(trans('challenge.error_loading'))
        })
}

function get_types(){
    m.request('/api/challenge_types?visibility=public').then(d => {
        challenge_state.types = d.feed;
        challenge_state.challenge.id_type = 1; // only set default if creating new challenge
    }).catch(err => {
        alert('Something went wrong, please refresh page.')
    })
}

function init(rootElement, id_challenge) {

    if (!rootElement) {
        return;
    }

    if (id_challenge) {
        challenge_state.id_challenge = id_challenge;
        challenge_state.mode = 'update';

        get_challenge();
    }

    m.mount(rootElement, Challenge);
}

export default init;
